import { ComponentParams, ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';
import { ImportedData } from 'lib/imported-data/ImportedData.types';
import { TranslationOptionsParams, AnchorTargetParams } from 'src/shared/shared.types';

export type I03SparkleProviderProfileProps = {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams & I03SparkleProviderProfileParams;
  importedData: ImportedData;
};

export type I03SparkleProviderProfileParams = ComponentParams &
  TranslationOptionsParams &
  AnchorTargetParams;
